import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category', label: '品种品类' },
  { path: '/articles', label: '梨果资讯' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer"
          >
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-leaf-fill text-lg md:text-xl"></i>
            </div>
            <span className="font-heading text-xl md:text-2xl font-bold whitespace-nowrap">
              惠美梨
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    isActive
                      ? 'text-primary-600 bg-primary-100/70'
                      : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/category"
              className="ml-3 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即选购
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? 'text-primary-600 bg-primary-100/70'
                      : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/category"
              className="mt-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即选购
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}